import React from "react";
import { FormattedMessage } from "react-intl";
import { Row, Col, Descriptions, Divider } from "antd";

import ClientTable from "./clientTable";

const UserClients = ({ data }) => (
  <>
    <Divider />
    <Row gutter={[0, 40]}>
      <Col>
        <Descriptions column={4} layout="vertical" bordered>
          <Descriptions.Item
            label={
              <FormattedMessage id="user.firstname" defaultMessage="Jméno" />
            }
          >
            {data.firstname}
          </Descriptions.Item>
          <Descriptions.Item
            label={
              <FormattedMessage id="user.lastname" defaultMessage="Příjmení" />
            }
          >
            {data.lastname}
          </Descriptions.Item>
          <Descriptions.Item
            label={
              <FormattedMessage
                id="user.username"
                defaultMessage="Uživatelské jméno"
              />
            }
          >
            {data.username}
          </Descriptions.Item>
          <Descriptions.Item
            label={<FormattedMessage id="user.email" defaultMessage="Email" />}
          >
            {data.email}
          </Descriptions.Item>
        </Descriptions>
      </Col>
    </Row>
    <Row gutter={[0, 40]}>
      <Col>
        <ClientTable clients={data.clients} />
      </Col>
    </Row>
  </>
);

export default UserClients;
